import RoomAmenities, { RoomAmenitiesProps } from './roomAmenities'

// No logic — passthrough kept for the two-file pattern; labels resolved by the caller.
const RoomAmenitiesWrapper = (props: RoomAmenitiesProps) => {
    return <RoomAmenities {...props} />
}

export { RoomAmenitiesWrapper }
export type { RoomAmenitiesProps }
export default RoomAmenitiesWrapper
